import React, {useState,useContext} from "react";
import { useEffect } from "react";
import {ROOM_CALL_STATE} from '../../Conquer/ROOMS/RoomInstance/RoomInstance'
import { ConquerContext } from "../contexts/ConquerContext";
import ChatCalling from "../screens/Chat/ChatCalling";
import { ModalContext } from "../contexts/Modal/ModalContext";

function useCallStatus( roomInstance, peer ){

    const conquer = useContext( ConquerContext );
    const {show,hide} = useContext( ModalContext );
    const [status, setStatus] = useState( ROOM_CALL_STATE.IDLE );

    function updateState( state ){

        setStatus( state );
        
        if( state == ROOM_CALL_STATE.IN_PROGRESS || state == ROOM_CALL_STATE.IDLE ) return ( hide(), conquer.Sounds.Ambiance.stop() ); 
        
        if( state != ROOM_CALL_STATE.CALLING && state != ROOM_CALL_STATE.RECEIVED ) return;

        show({title: 'CALL', content: <ChatCalling roomInstance={ roomInstance } peer={peer} isCaller={ state == ROOM_CALL_STATE.CALLING }/>, closeOutside: false, onClose: onClose });
        conquer.Sounds.Ambiance.loop( 'Casual - Level 2 (Loop_02)' );

    }

    function onClose(){
        peer?.answerCall( false );
    }

    useEffect( () => {        
        if( roomInstance ) roomInstance.onCallState = updateState;
    }, [ roomInstance, peer ]);

    return status;

};

export default useCallStatus;